import React from "react";
import PropTypes from "prop-types";
import MainMenuCardEverscoreStyled from "./MainMenuCardEverscore.styled";

const MainMenuCardEverscore = React.memo(props => {
    const {id, className, heading, type, setMenuOpen } = props;
    const onLinkClick = () => {
        setMenuOpen(false)
    }
    return (
        <MainMenuCardEverscoreStyled data-testid="link_click" onClick={onLinkClick} className={className} to={`/shop?${type}=${id}`}>
            <h4 className="main_menu-card__heading t-shop-link-everscore">{heading}</h4>
        </MainMenuCardEverscoreStyled>
    );
});

MainMenuCardEverscore.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    setMenuOpen: PropTypes.func.isRequired
};

export default MainMenuCardEverscore;
